export const handleCommonCases = (
  builder,
  asyncThunk,
  { loadingKey = "loading", onPending, onFulfilled, onRejected } = {},
) => {
  builder
    .addCase(asyncThunk.pending, (state, action) => {
      // Always set loading state if loadingKey is provided
      if (loadingKey) {
        state[loadingKey] = true;
        state.error = null;
      }

      // Then run custom onPending logic if provided
      if (onPending) {
        onPending(state, action);
      }
    })

    .addCase(asyncThunk.fulfilled, (state, action) => {
      if (loadingKey) {
        state[loadingKey] = false;
      }

      const { statusCode, success } = action?.payload || {};
      if (statusCode === 200 && success) {
        onFulfilled?.(state, action);
      }
    })

    .addCase(asyncThunk.rejected, (state, action) => {
      if (loadingKey) {
        state[loadingKey] = false;
      }
      state.error = action.payload || {};
      onRejected?.(state, action);
    });
};
